import { Dropdown as DropdownV5, DropdownProps as DropdownPropsV5 } from 'antd5';
import { Dropdown as DropdownV4, DropDownProps as DropdownPropsV4 } from 'antd';
import { Version4Props, Version5Props } from '../types';

interface PropsV5 extends Version5Props, DropdownPropsV5 {}
interface PropsV4 extends Version4Props, DropdownPropsV4 {}
type Props = PropsV5 | PropsV4;

export const Dropdown: React.FunctionComponent<Props> = ({ _version = 5, ...props }) => {
  if (_version === 4) {
    const { arrow, overlay, placement } = props;

    return (
      <DropdownV4
        {...props}
        // these checks are to make TS happy due to discrepancies between antd
        // v4 and v5 - they essentially do nothing
        arrow={typeof arrow === 'undefined' || typeof arrow === 'boolean' ? arrow : undefined}
        overlay={overlay ?? <></>}
        placement={placement !== 'top' && placement !== 'bottom' ? placement : undefined}
      />
    );
  }

  return <DropdownV5 {...props} />;
};
